import { FC } from 'react';
import { Link as EnovaLink, Typography } from 'enova-frontend-components';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { BuildingScreenTab, getBuildingScreenPath } from '../../../utils/navigation';

interface PublishedErrorLinkProps {
  buildingId: string;
  tab: BuildingScreenTab;
  i18nKey: string;
}

export const PublishedErrorLink: FC<PublishedErrorLinkProps> = ({ buildingId, tab, i18nKey }) => {
  const navigate = useNavigate();

  const path = getBuildingScreenPath({
    buildingId,
    tab
  });

  return (
    <Typography>
      <Trans
        i18nKey={i18nKey}
        components={[<EnovaLink button key={0} variant="inherit" onClick={() => navigate(path)} />]}
      />
    </Typography>
  );
};
